import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RedirectionGuard  {
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Legacy ADAL guard removed; allow navigation by default.
        return true;
    }
}
